import { getDistanceFromLatLonInKm, LatLng } from '@pedix-workspace/utils';
import { ApiV1_Subsidiary } from '../api-v1.types';

export function sortSubsidiariesByDistance(
  subsidiaries: ApiV1_Subsidiary[],
  coordinates: LatLng,
): ApiV1_Subsidiary[] {
  const subsidiariesDistances: Record<string, number> = {};

  subsidiaries.forEach(subsidiarie => {
    const subsidiarieCoordinates = subsidiarie?.addressDetails?.coordinates;
    const distance = subsidiarieCoordinates
      ? getDistanceFromLatLonInKm(coordinates, subsidiarieCoordinates)
      : Number.MAX_SAFE_INTEGER;

    subsidiariesDistances[subsidiarie.slug] = distance;
  });

  return subsidiaries.slice(0).sort((subsidiarieA, subsidiarieB) => {
    return subsidiariesDistances[subsidiarieA.slug] - subsidiariesDistances[subsidiarieB.slug];
  });
}
